import React, { useState, useEffect } from 'react';
import {
    Box, TextField, Button, IconButton, Modal, Typography, Paper,
    Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
    MenuItem, Select, FormControl, InputLabel, CircularProgress, Grid, Container
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import AccountCircle from '@mui/icons-material/AccountCircle';
import { useLocation } from 'react-router-dom';

import customerService from '../services/customerService';
import { countryService } from '../services/countryService';
import { regionService } from '../services/regionService';
import { provinceService } from '../services/provinceService';
import { communeService } from '../services/communeService';
import { BranchService } from '../services/branchService';

const CustomersPage = () => {
    // Estado inicial del cliente.
    const [customer, setCustomer] = useState({    
        IdCountry: '',
        IdDistrito: '',
        IdBranch: '',
        FirstName: '',
        MiddleName: '',
        LastName: '',
        SecondLastName: '',
        Identifier: '',
        Email: '',
        Telephone: '',
        Address: '',
        Observations: '',
        IdStatus: '', 
    });

 

    const location = useLocation();
    const customerData = location.state;


    // Estados para manejar los datos del formulario.
    const [countries, setCountries] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState('');
    const [regiones, setRegiones] = useState([]);
    const [selectedRegion, setSelectedRegion] = useState('');
    const [provincias, setProvincias] = useState([]);
    const [selectedProvincia, setSelectedProvincia] = useState('');
    const [comunas, setComunas] = useState([]);
    const [selectedComuna, setSelectedComuna] = useState('');
    const [sucursales , setSucursal]= useState([]);
    const [selectedSucursal,setSelectedSucursal]= useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

 

    // Cargar países y regiones al montar el componente.
    useEffect(() => {
        fetchCountry();
        fetchRegion();
        fecthSucursales();
    }, []);



    useEffect(() => {
        if (selectedRegion) 
            fetchProvincias(selectedRegion);
    }, [selectedRegion]);

    useEffect(() => {
        if (selectedProvincia)
            fetchComunas(selectedProvincia);
    }, [selectedProvincia]);


    const handleChange = (e) => {
        const { name, value } = e.target;
        setCustomer(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleCountryChange = (event) => {
        const countryId = event.target.value;        
        setSelectedCountry(countryId);
    };

    const handleSucursalChange = (event)=>{
       const idBranch = event.target.value;  
        setSelectedSucursal(idBranch);
    };


    const handleRegionChange = (event) => {
        const idRegion = event.target.value;
        setSelectedRegion(idRegion);
        setSelectedProvincia(''); // Reiniciar provincia seleccionada
        setSelectedComuna(''); // Reiniciar comuna seleccionada
        setComunas([]); // Limpiar comunas
    };

    const handleProvinciaChange = (event) => {
        const idProvidence = event.target.value;
        setSelectedProvincia(idProvidence);
        setSelectedComuna('');
    };

    const handleComunaChange = (event) => {
        const comunaId = event.target.value;
        setSelectedComuna(comunaId);
    };


    const fetchCountry = async () => {
        try {
            setLoading(true);
            const data = await countryService.getAllCountry();
            setCountries(data);
            setLoading(false);
        } catch (err) {
            setError('Error al cargar los roles');
            setLoading(false);
        }
    };

    const fetchRegion = async () => {
        try {
            setLoading(true);
            const data = await regionService.getAllRegion();
            setRegiones(data);
            setLoading(false);
        } catch (err) {
            setError('Error al cargar los roles');
            setLoading(false);
        }
    };

    const fetchProvincias = async (idRegion) => {
        try {
            setLoading(true);
            const data = await provinceService.getProvincesByRegion(idRegion);

            setProvincias(data);
            setLoading(false);
        } catch (err) {
            setError('Error al cargar las provincias');
            setLoading(false);
        }
    };
    const fetchComunas = async (idProvidence) => {
        try {
            setLoading(true);
            const data = await communeService.getCommunesByProvince(idProvidence);
            setComunas(data);
            setLoading(false);
        } catch (err) {
            setError('Error al cargar las comunas');
            setLoading(false);
        }
    };

    const fecthSucursales = async ()=>{
        try {
            setLoading(true);
            const data = await BranchService.getAllBrach();
            setSucursal(data);
            setLoading(false);
        } catch (err) {
            setError('Error al cargar las comunas');
            setLoading(false);
        }
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!customer.Identifier || !customer.FirstName || !customer.LastName || !customer.Email) {
            alert('Please fill in all required fields.');
            return;
        }
        try {
            await customerService.createCustomer(customer);
            alert('Customer created successfully');
        } catch (error) {
            console.error('Error creating customer', error);
            alert('Error creating customer');
        }
    };
    

    return (
        <Container maxWidth="lg">
            <Paper elevation={3} sx={{ p: 4, mt: 4 }}>
                <Typography variant="h5" gutterBottom>
                    ENTREVISTA
                </Typography>
                <Box component="form" noValidate autoComplete="off" onSubmit={handleSubmit}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                required
                                id="identifier"
                                label="Rut Cliente"
                                name="Identifier"
                                value={customerData?.rut || ''}
                                onChange={handleChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                required
                                id="firstName"
                                label="Fecha Contacto"
                                name="FirstName"
                                value={customerData?.createDate || ''}
                                onChange={handleChange}
                            />

                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                required
                                id="firstName"
                                label="Nombre Cliente"
                                name="FirstName"
                                value={customerData?.properties?.firstName || ''}
                                onChange={handleChange}
                            />

                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                required
                                id="lastName"
                                label="Apellido Cliente"
                                name="LastName"
                                value={customerData?.properties?.lastName || ''}
                                onChange={handleChange}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                required
                                id="email"
                                label="Email"
                                name="Email"
                                value={customerData?.properties?.email || ''}
                                onChange={handleChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                required
                                id="telephone"
                                label="Telefono"
                                name="Telephone"
                                value={customerData?.properties?.phone || ''}
                                onChange={handleChange}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                required
                                id="address"
                                label="Direccion"
                                name="Address"
                                value={customer.Address}
                                onChange={handleChange}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth required>
                                <InputLabel id="country-label">País de Nacimiento</InputLabel>
                                <Select
                                    labelId="country-label"
                                    id="country"
                                    value={selectedCountry}
                                    onChange={handleCountryChange}
                                    label="País de Nacimiento"
                                >
                                    <MenuItem value="">
                                        <em>-- Selecciona un País --</em>
                                    </MenuItem>
                                    {countries.map(country => (
                                        <MenuItem key={country.id} value={country.id}>
                                            {country.description}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth required>
                                <InputLabel id="region-label">Región</InputLabel>
                                <Select
                                    labelId="region-label"
                                    id="region"
                                    value={selectedRegion}
                                    onChange={handleRegionChange}
                                    label="Región"
                                >
                                    <MenuItem value="">
                                        <em>-- Selecciona una Región --</em>
                                    </MenuItem>
                                    {regiones.map(region => (
                                        <MenuItem key={region.id} value={region.id}>
                                            {region.description}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth required>
                                <InputLabel id="provincia-label">Provincia</InputLabel>
                                <Select
                                    labelId="provincia-label"
                                    id="provincia"
                                    value={selectedProvincia}
                                    onChange={handleProvinciaChange}
                                    label="Provincia"
                                    disabled={!selectedRegion}
                                >
                                    <MenuItem value="">
                                        <em>-- Selecciona una Provincia --</em>
                                    </MenuItem>
                                    {provincias.map(provincia => (
                                        <MenuItem key={provincia.id} value={provincia.id}>
                                            {provincia.description}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth required>
                                <InputLabel id="comuna-label">Comuna</InputLabel>
                                <Select
                                    labelId="comuna-label"
                                    id="comuna"
                                    value={selectedComuna}
                                    onChange={handleComunaChange}
                                    label="Comuna"
                                    disabled={!selectedProvincia}
                                >
                                    <MenuItem value="">
                                        <em>-- Selecciona una Comuna --</em>
                                    </MenuItem>
                                    {comunas.map(comuna => (
                                        <MenuItem key={comuna.id} value={comuna.id}>
                                            {comuna.description}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth required>
                                <InputLabel id="sucursal-label">Sucursal</InputLabel>
                                <Select
                                    labelId="sucursal-label"
                                    id="sucursal"
                                    value={selectedSucursal}
                                    onChange={handleSucursalChange}
                                    label="sucursal"
                                >
                                    <MenuItem value="">
                                        <em>-- Selecciona una Sucursal --</em>
                                    </MenuItem>
                                    {sucursales.map(sucursal => (
                                        <MenuItem key={sucursal.id} value={sucursal.id}>
                                            {sucursal.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                id="observations"
                                label="Observaciones"
                                name="Observations"
                                value={customer.Observations}
                                onChange={handleChange}
                                multiline
                                rows={4}
                            />
                        </Grid>
                    </Grid>
                    <Box sx={{ mt: 3, display: 'flex', justifyContent: 'right' }}>
                        <Button
                            variant="contained"
                            startIcon={<AddIcon />}
                            type="submit"
                            size="large"
                        >
                           Guardar y Continuar
                        </Button>
                    </Box>
                </Box>
            </Paper>
        </Container>
    );
};

export default CustomersPage;